import {Bar, BarChart, Tooltip, XAxis, YAxis, Legend} from "recharts";
import React from "react";

const domain = (data) => {

        return data.reduce((acc, yr) => {

                acc[0] = Math.min(acc[0], yr.discounted);
                acc[0] = Math.min(acc[0], yr.net);
                acc[1] = Math.max(acc[1], yr.discounted);
                acc[1] = Math.max(acc[1], yr.net);
                return acc;
        }, [0,0]);
};

export default ({data}) =>
    <BarChart width={600} height={400} data={data}>
        <XAxis  dataKey="year"/>
        <YAxis
            label={{value: 'Cash flow', angle: -90, position: 'left'}}
            domain={domain(data)}
        />
        <Legend/>
        <Tooltip/>
        <Bar
            type="monotone"
            dataKey="net"
            stroke="#8884d8"
            fill="#8884d8"
            tooltip
            name="Net cumulated"
        />
        <Bar
            name="Discounted cumulated"
            type="monotone"
            dataKey="discounted"
            stroke="#82ca9d"
            fill="#82ca9d"
        />
    </BarChart>
